import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDirectusComponent } from './simple-icons-directus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDirectusComponent ],
    exports:      [ SimpleIconsDirectusComponent ],
    bootstrap:    []
})
export class SimpleIconsDirectusModule {}
